<template>
    <div class="timeline-container">
        <div class="selected-date" v-if="campaign_datas_filtered[selected_campaign_data]">{{ campaign_datas_filtered[selected_campaign_data].date }}</div>
        <div class="selected-date" v-else>Sin datos</div>
        <input class="slider" type="range" min="0" :max ="campaign_datas_filtered.length - 1" step="1" v-model="selected_campaign_data" :disabled="transect_status==3"/>
        <!-- <input class="slider" type="range" min="0" :max ="campaign_datas_filtered.length - 1" step="1" v-model="selected_campaign_data" /> -->
        <div class="slider-marks-container">
            <div class="slider-mark" v-for="(item, index) in campaign_datas_filtered" v-bind:key="index"></div>
        </div>
        <div class="first-last-date">
            <div v-if="campaign_datas_filtered[0]"> {{campaign_datas_filtered[0].date}} </div>
            <div v-if="campaign_datas_filtered[1]"> {{campaign_datas_filtered[campaign_datas_filtered.length - 1].date}} </div>
        </div>
    </div>
</template>

<script>
  // Vuex
  import { mapGetters } from 'vuex'

  export default {
    name: 'panelTimeline',
    data: function () {
        return {
            selected_param_text: '',
            hover_param: null
        }
    },
    computed: {
        ...mapGetters(
            "map_params",{
                campaign_datas_filtered: 'campaign_datas_filtered',
                transect_status: 'transect_status'
            }
        ),
        selected_campaign_data: {
            set (campaign_data) { this.$store.dispatch('map_params/change_selected_campaign_data', parseInt(campaign_data)); },
            get () { return this.$store.state.map_params.selected_campaign_data}
        },
    },
    mounted () {
        this.getCampaignDatas()
    },
    methods: {
        getCampaignDatas: function () {
            this.$store.dispatch('map_params/getCampaignDatas')
        }
    }
  }
</script>

<style scoped>
    .timeline-container {
        display: flex;
        flex-direction: column;
        padding: 20px;
    }
    .selected-date {
        color: #447998;
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 1rem;
    }
    .slider {
        -webkit-appearance: none;  /* Override default CSS styles */
        appearance: none;
        width: 100%;
        height: 4px;
        background: #447998AA;
        outline: none; /* Remove outline */
    }
    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 19px;
        height: 19px;
        background: #FFFFFF;
        cursor: pointer;
        border: none;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3);
    }

    .slider::-moz-range-thumb {
        width: 19px;
        height: 19px;
        background: #FFFFFF;
        cursor: pointer;
        border: none;
        box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3);
    }
    .slider-marks-container {
        width: 100%;
        height: 3px;
        margin-top: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        z-index: -10;
        padding-left: 8px;
        padding-right: 8px;
    }
    .slider-mark {
        width: 4px;
        height: 4px;
        background-color: #447998AA;
        border-radius: 50px;
    }
    .first-last-date {
        display:flex;
        flex-direction: row;
        justify-content: space-between;
        color: #447998;
        font-size: 0.8rem;
        margin-top: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/mapparams/panelTimeline.vue